import { Dataset } from '~/packages/general/system/bulk/systemBulk.data'
import { parseDateTime, stringifyDateTime } from '~/prix/types/dateTime'
import clearString from '~/prix/utils/bulk/clearString'

const attendanceMedicalProcedure: Dataset = {
  schema: 'public_health',
  table: 'attendance_medical_procedure',
  columnTransformMap: {
    original_id: original => original,
    data_source_id: original => original,
    attendance_original_id: original => original,
    sigtap_code: original => original,
    name: original => clearString(original as string),
    created_at: original => stringifyDateTime(parseDateTime(original as string)),
    updated_at: original => stringifyDateTime(parseDateTime(original as string)),
  },
}

export default attendanceMedicalProcedure
